export default "__VITE_ASSET__pE9x8ICf__"